<template>
    <BreadCrumb PageTitle="Liste des organes" />
    <ListOrganes />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue"
import ListOrganes from "@/components/Organes/ListOrganes.vue";

export default defineComponent({
    name: "ListeOrganePage",
    components: {
        BreadCrumb,
        ListOrganes,
    },
});
</script>